import styled from 'styled-components';
import { Colors, mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  overflow-y: auto;
  padding: 0 20px 20px;

  ${mediaQueries.laptop} {
    padding: 12px 24px;
  }
`;
export const LoaderContainer = styled.div `
  flex: 1;

  height: 100px;
  min-height: 0;
`;
export const Header = styled.div `
  font-weight: 600;
  color: ${Colors.GS1000};
`;
export const HeaderWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
`;
export const ThemesList = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding-bottom: 8px;
`;
export const ActiveThemeWrapper = styled.div `
  padding-bottom: 26px;
`;
